@file:OptIn(ExperimentalStdlibApi::class)

package it.neckar.projects.pvplanner


import it.neckar.projects.common.Port
import it.neckar.projects.common.ServiceDescriptor
import it.neckar.projects.common.ServiceName

/**
 * Enum that contains all active services related to the Lizergy Planner
 */
enum class PvPlannerService(
  /**
   * The name of the service - as defined in the docker-compose.yml
   */
  override val serviceName: ServiceName,
  override val apiPrefix: String,
  override val port: Port,
) : ServiceDescriptor {
  AuthService(ServiceName("auth-service"), "api/auth", PvPlannerPorts.authService),
  CommentsService(ServiceName("comments-service"), "api/comments", PvPlannerPorts.commentsService),
  GeoInformationService(ServiceName("geoinformation-service"), "api/geo", PvPlannerPorts.geoInformationService),
  PdfReportService(ServiceName("pdf-report-service"), "api/pdf", PvPlannerPorts.pdfReportService),
  PdfPreviewService(ServiceName("pdf-preview-service"), "api/pdf-preview", PvPlannerPorts.pdfPreviewService),
  ProjectQueryService(ServiceName("project-query-service"), "api/projects", PvPlannerPorts.projectQueryService),
  ;

  companion object {
    val essentialEntries: List<PvPlannerService>
      get() = listOf(
        AuthService,
        ProjectQueryService,
      )
  }
}
